import { Browser, EventHandler, L10n, createElement } from '@syncfusion/ej2-base';
/**
 *  To show the dialog is used to insert image on picture Content Control.
 */
export class PicContentControlDialog {
    /**
     * @param {DocumentHelper} documentHelper - Specifies the document helper
     * @private
     */
    constructor(documentHelper) {
        /**
         * @private
         * @returns {void}
         */
        this.onCancelButtonClick = () => {
            this.documentHelper.dialog2.hide();
            this.documentHelper.updateFocus();
        };
        /**
         * @private
         * @returns {void}
         */
        this.onInsertPicClick = () => {
            this.documentHelper.dialog2.hide();
            this.imagePicker = createElement('input', {
                attrs: { type: 'file', accept: '.jpg,.jpeg,.png,.bmp,.svg' }, className: 'e-de-ctnr-file-picker'
            });
            if (Browser.isIE) {
                document.body.appendChild(this.imagePicker);
            }
            this.imagePicker.value = '';
            this.imagePicker.click();
            EventHandler.add(this.imagePicker, 'change', this.onImageChange, this);
        };
        this.documentHelper = documentHelper;
    }
    getModuleName() {
        return 'PicContentControlDialog';
    }
    /**
     * @private
     * @returns {void}
     */
    show() {
        const localValue = new L10n('documenteditor', this.documentHelper.owner.defaultLocale);
        localValue.setLocale(this.documentHelper.owner.locale);
        this.localeValue = localValue;
        this.documentHelper.dialog2.header = localValue.getConstant('Insert Pictures');
        this.documentHelper.dialog2.showCloseIcon = true;
        this.documentHelper.dialog2.allowDragging = true;
        this.documentHelper.dialog2.position = { X: 'center', Y: 'center' };
        this.documentHelper.dialog2.width = 'auto';
        this.documentHelper.dialog2.beforeOpen = this.documentHelper.updateFocus;
        this.documentHelper.dialog2.buttons = [{
                click: this.onInsertPicClick,
                buttonModel: { content: localValue.getConstant('Upload from computer'), iconCss: 'e-icons e-de-ctnr-upload', iconPosition: 'Left' }
            }];
        this.documentHelper.dialog2.dataBind();
        this.documentHelper.dialog2.show();
    }
    onImageChange() {
        const file = this.imagePicker.files[0];
        const fileReader = new FileReader();
        fileReader.onload = () => {
            this.insertImage(fileReader.result);
        };
        fileReader.readAsDataURL(file);
    }
    insertImage(data) {
        this.image = document.createElement('img');
        const documentHelper = this.documentHelper;
        const container = this.container;
        this.image.addEventListener('load', function () {
            documentHelper.owner.editorModule.insertImageInternal(data, true, this.width, this.height, this.alt);
            //to upload an image newly = false, this condition applies and to replace the new image = true , this condition not applies
            if (!documentHelper.owner.selection.isImageSelected) {
                documentHelper.owner.selection.handleShiftLeftKey();
                documentHelper.owner.editor.insertContentControl('Picture');
            }
        });
        this.image.src = data;
    }
    /**
     * @private
     * @returns {void}
     */
    destroy() {
        this.documentHelper = undefined;
        if (this.imagePicker) {
            this.imagePicker.remove();
            this.imagePicker = undefined;
        }
        if (this.image) {
            this.image.remove();
            this.image = undefined;
        }
    }
}
